import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { COMET_USER_COHORT } from '#pplx/frontend/apps/ask/queries/upsell-queries/constants.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { homepageWidgetsClient } from '#pplx_generated/typespec/rest/homepage_widgets/client.js';
/**
 * Add user to a whitelisted cohort
 * @param cohort - The cohort name to add the user to (must be whitelisted in ConfigBoard)
 */
export const addToUserCohort = async (cohort) => {
    try {
        const { error, response } = await homepageWidgetsClient.POST('/rest/homepage-widgets/upsell/add-to-cohort', 'add user to cohort', {
            body: { cohort },
            timeoutMs: getQueryTimeoutMs(),
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
            });
        }
        return response.ok;
    }
    catch (error) {
        logger.error('Error adding user to cohort', {
            error,
            cohort,
        });
        return false;
    }
};
/**
 * Add user to Comet users cohort to track that they've downloaded Comet
 */
export const addToCometUserCohort = async () => {
    return addToUserCohort(COMET_USER_COHORT);
};
//# sourceMappingURL=addToUserCohort.js.map